/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["textarea[_ngcontent-%COMP%]{resize:vertical}"];
export { styles as styles };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/view-request/request-reassignment-modal/request-reassignment-modal.component.css.shim.ngstyle.js.pre-build-optimizer.js